import React from "react";

export default function MSAccess_Time() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_Time</h1>
      <p>This is the MSAccess_Time component generated from the SQL JSON.</p>
    </div>
  );
}
